export const GET_FG_REPORT_REQUEST = "GET_FG_REPORT_REQUEST";
export const GET_FG_REPORT_SUCCESS = "GET_FG_REPORT_SUCCESS";
export const GET_FG_REPORT_FAILURE = "GET_FG_REPORT_FAILURE";

export const GET_FG_REPORT_DOWNLOAD_REQUEST = "GET_FG_REPORT_DOWNLOAD_REQUEST";
export const GET_FG_REPORT_DOWNLOAD_SUCCESS = "GET_FG_REPORT_DOWNLOAD_SUCCESS";
export const GET_FG_REPORT_DOWNLOAD_FAILURE = "GET_FG_REPORT_DOWNLOAD_FAILURE";

export const GET_FG_TYPE_REQUEST = "GET_FG_TYPE_REQUEST";
export const GET_FG_TYPE_SUCCESS = "GET_FG_TYPE_SUCCESS";
export const GET_FG_TYPE_FAILURE = "GET_FG_TYPE_FAILURE";


export const GET_FG_MODAL_REQUEST = "GET_FG_MODAL_REQUEST";
export const GET_FG_MODAL_SUCCESS = "GET_FG_MODAL_SUCCESS";
export const GET_FG_MODAL_FAILURE = "GET_FG_MODAL_FAILURE";
